import React from 'react'

const Thirty_five = () => {
    return (
        <div className='container'>
            <h1>Insertion sort</h1>
            <p>
                Insertion sort is a simple sorting algorithm that works similar
                to the way you sort playing cards in your hands. The array is virtually
                split into a sorted and an unsorted part. Values from the unsorted part are
             picked and placed at the correct position in the sorted part. <br />
                <b>Example</b>
            12, 11, 13, 5, 6 <br />
Let us loop for i = 1 (second element of the array) to 4 (last element of the array)<br />
i = 1. Since 11 is smaller than 12, move 12 and insert 11 before 12 <br />
11, 12, 13, 5, 6<br />
i = 2. 13 will remain at its position as all elements in A[0..I-1] are smaller than 13 <br />
11, 12, 13, 5, 6<br />
i = 3. 5 will move to the beginning and all other elements from 11 to 13 will move one position ahead of their current position. <br />
5, 11, 12, 13, 6<br />
i = 4. 6 will move to position after 5, and elements from 11 to 13 will move one position ahead of their current position. <br />
5, 6, 11, 12, 13 <br />
</p>
            
            <h3>Algorithm to do inserton sort</h3>
            To sort an array of size n in ascending order:  <br />
1: Iterate from arr[1] to arr[n] over the array. <br />
2: Compare the current element (key) to its predecessor. <br />
3: If the key element is smaller than its predecessor, compare it to the elements before. Move the greater elements one position up to make space for the swapped element. <br />
            <div className='containers'>
                <code className='library'>#include</code>    &lt;math.h&gt;<br />
                <code className='library'>#include</code> &lt;stdio.h&gt;<br />

                <code className='comment'>/* Function to sort an array using insertion sort*/</code><br />
                <code className='keywords'>void</code> insertionSort(int arr[], int n)<br />
&#123;<br />
                <code className='keywords'>	int </code>i, key, j;<br />
                <code className='keywords'>for</code> (i = 1; i &lt; n; i++) &#123;<br />
		key = arr[i];<br />
		j = i - 1;<br />

                    <code className='comment'>	/* Move elements of arr[0..i-1], that are<br /></code>
                    <code className='comment'>greater than key, to one position ahead<br /></code>
                    <code className='comment'>of their current position */<br /></code>
                    <code className='keywords'>while</code> (j &gt;= 0 && arr[j] &gt; key) &#123;<br />
			arr[j + 1] = arr[j];<br />
			j = j - 1;<br />
		&#125;<br />
		arr[j + 1] = key;<br />
	&#125;<br />
&#125;<br />

                    <code className='comment'>// A utility function to print an array of size n</code><br />
                    <code className='keywords'>void</code> printArray(int arr[], int n)<br />
&#123;<br />
                    <code className='keywords'>	int</code> i;<br />
                    <code className='keywords'>	for</code> (i = 0; i &lt; n; i++)<br />
                    <code className='library'>		printf</code>("%d ", arr[i]);<br />
                    <code className='library'>	printf</code>("\n");<br />
&#125;<br />

                    <code className='comment'>/* Main function */</code><br />
                    <code className='keywords'>int</code> main()<br />
&#123;<br />
                    <code className='keywords'>	int</code> arr[] = &#123; 12, 11, 13, 5, 6 &#125;;<br />
                    <code className='keywords'>	int</code> n = sizeof(arr) / sizeof(arr[0]);<br />

	insertionSort(arr, n);<br />
	printArray(arr, n);<br />

	return 0;<br />
&#125;<br />
       </div>
            </div>
    )
}

export default Thirty_five
